"use strict";
/**
 * Provider-neutral payment DTOs for PaymentProviderPort (WS2).
 * Finmo field names are normalized to camelCase at the port boundary.
 */
Object.defineProperty(exports, "__esModule", { value: true });
